import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchCartList } from '../utils/cart';

export const useCartValidation = () => {
  const [cartData, setCartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasItems, setHasItems] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadCartData = async () => {
      try {
        setLoading(true);
        console.log('useCartValidation: Starting cart validation...');
        const response = await fetchCartList();
        console.log('useCartValidation: API response:', response);
        
        // Handle the response structure from fetchCartList
        if (response && response.status === 200 && response.data) {
          setCartData(response.data);
          // Check if cart has items
          const hasCartItems = response.data.cart_items && 
                              response.data.cart_items.length > 0;
          setHasItems(hasCartItems);
          
          // If no items and we're on checkout page, redirect to cart
          if (!hasCartItems && window.location.pathname === '/check-out') {
            console.log('useCartValidation: No items, redirecting to /my-cart');
            navigate('/my-cart');
          }
        } else if (response && response.data && response.data.success) {
          // Handle case where response.data has success property
          setCartData(response.data);
          const hasCartItems = response.data.cart_items && 
                              response.data.cart_items.length > 0;
          setHasItems(hasCartItems);
          
          // If no items and we're on checkout page, redirect to cart
          if (!hasCartItems && window.location.pathname === '/check-out') {
            console.log('useCartValidation: No items, redirecting to /my-cart');
            navigate('/my-cart');
          }
        } else {
          console.log('useCartValidation: Invalid response structure:', response);
          setHasItems(false);
          // If no cart data and we're on checkout page, redirect to cart
          if (window.location.pathname === '/check-out') {
            console.log('useCartValidation: Invalid response, redirecting to /my-cart');
            navigate('/my-cart');
          }
        }
      } catch (error) {
        console.error('Error loading cart data:', error);
        setHasItems(false);
        // If error and we're on checkout page, redirect to cart
        if (window.location.pathname === '/check-out') {
          navigate('/my-cart');
        }
      } finally {
        setLoading(false);
      }
    };

    loadCartData();
  }, [navigate]);

  const refreshCart = async () => {
    await loadCartData();
  };

  return {
    cartData,
    loading,
    hasItems,
    refreshCart
  };
}; 